import React, { Component, Fragment } from "react";
import _ from "lodash";
import Template1 from "./template1";
import ProductDetails from "./productDetails";

import InputButton from "../../../../../../components/ZUILib/InputButton";

import TextInput from "../../../../../../components/ZUILib/TextInput";
import commonUtil from "../../../../../../utils/commonUtil";

import * as defaultConst from "../../../../../../utils/clientConstant";
import EmptyGiftListIndicator from '../EmptyGiftListIndicator';
import WapFilterModal from "../../WapFilterModal";
import ComprasModalOverlay from "../../components/ComprasPersonales/components/ComprasModalOverlay";
import ModalPopover from "../../../../../../components/ZUILib/ModalPopover";
import Accordion from "../../components/Accordion";
import RadioButton from "../../../../../../components/ZUILib/RadioButton";
import Template2 from "../RegistradosContent/template2";
import GiftListCategories from "../../components/GiftListContent/GiftListCategories";
import DownloadPDFWithoutPreview from "../../../../../../components/DownloadPDFWithoutPreview";
import pdfUtil from "../../../../../../utils/PDFUtil";
import AddGiftsButton from "../../components/GiftListContent/AddGiftsButton";

const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];

let state = {
  displayProductPage: false,
  filteringParameters: [],
  searchKeyword: "",
  sortingType: "Ascending",
  selectedGiftItem: "",
  searchFlag: true,
};

 const pageName = 'lista-de-regalos';

class FilterTag extends Component {
  render() {
    const { label, onRemove } = this.props;

    return (
      <div className="filter-tag">
        <span>{label}</span>
        <span
        className="remove-tag"
          onClick={onRemove}
        >
          ×
        </span>
      </div>
    );
  }
}

class ComprasPersonalesWAP extends Component {
  constructor(props) {
    super(props);
    this.selectedCategoryType = "";
    this.filterClearedCompras = false;
    this.selectedCategory = "";
    this.selectedBonusType = "";
    this.selectedBonus = "";
    this.sortType = "Ascending";
    this.filterTypeCompras = [];
    this.state = {
      ...state,
      appliedFilters: { category: null, bonusApplicable: null },
      originalPersonalShoppingList: _.isObject(props.originalPersonalShoppingList)
        ? props.originalPersonalShoppingList
        : { categoryList: [], filteringParameters: [], itemsInfo: [], links: [] },
      openCategoryFilterModal: false,
      openFilterModal: false,
      openBonusFilterModal: false,
      comprasModal: false,
      displaySelectedProductDetail: null,
      giftSectionType: null,
      seletedOption: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label'),
      activeCategory: '',
      categoryDepartmentId: [],
      tempCategoryName: '',
      totalItems: '',
      selectedFilters: [],
      activeFilters: [],
      showButton: false,
      filteredCategory: [],
      filteredData: [],
    };
    this.initialPersonalPurchaseList = props.initialPersonalPurchaseList || {};
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    state = this.state;
    window.removeEventListener('scroll', this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    const nextOriginalPersonalShoppingList = nextProps.originalPersonalShoppingList;
    const prevOriginalPersonalShoppingList = this.props.originalPersonalShoppingList;
    const originalPersonalShoppingListDidChange = nextOriginalPersonalShoppingList !== prevOriginalPersonalShoppingList;
    if (originalPersonalShoppingListDidChange && _.isObject(nextOriginalPersonalShoppingList)) {
      if (Number(nextOriginalPersonalShoppingList.currentPage) === 1 || !_.isArray(nextOriginalPersonalShoppingList.itemsInfo)) {
        this.setState({ originalPersonalShoppingList: nextOriginalPersonalShoppingList });
      } else {
        nextOriginalPersonalShoppingList.itemsInfo = [...prevOriginalPersonalShoppingList.itemsInfo, ...nextOriginalPersonalShoppingList.itemsInfo];
        this.setState({ originalPersonalShoppingList: nextOriginalPersonalShoppingList });
      }

      let appliedFilters = { category: null, bonusApplicable: null };
      if (_.isArray(nextOriginalPersonalShoppingList.filteringParameters)) {
        appliedFilters = nextOriginalPersonalShoppingList.filteringParameters.reduce(
          (acc, { type, value }) => ({ ...acc, [type]: value }),
          appliedFilters,
        );
      }
      this.setState({ appliedFilters });
    }
  }

  searchedValue = "";

  showBonusModal = () => {
    this.setState({ openBonusFilterModal: true });
  };
  showCategoryModal = () => {
    this.setState({ openCategoryFilterModal: true });
  };
  closeModalForBonus = () => {
    this.setState({ openFilterModal: true });
    this.setState({ openBonusFilterModal: false });
  };
  closeModalForCategory = () => {
    this.setState({ openFilterModal: true });
    this.setState({ openCategoryFilterModal: false });
  };
  showFilterModal = () => {
    this.setState({ openFilterModal: true });
  };
  closeFilterModal = () => {
    this.setState({ openFilterModal: false });
  };
  handleCategorySelection = (type, value, name) => {
    let fpType = "";
    const isRemove = false;
    if (type === "bonusApplicable") {
      fpType = "bonusApplicable";
      this.selectedBonusType = name;
    } else if (type === "category") {
      fpType = "category";
      this.selectedCategory = name;
    }
    this.updateFilterParams(fpType, value, isRemove);
  };
  updateFilterParams(fpType, value, isRemove) {
    const filteringParameters = this.state.filteringParameters;
    if (isRemove) {
      for (let i = 0; i < filteringParameters.length; i++) {
        if (filteringParameters[i].type === fpType) {
          filteringParameters.splice(i, 1);
        }
      }
    } else {
      const type = _.find(filteringParameters, { type: fpType });
      if (type) {
        type.value = value;
      } else {
        filteringParameters.push({ type: fpType, value });
      }
    }
    this.setState({
      filteringParameters,
    });

    this.props.handleSortAndFilter({
      searchKeyword: this.state.originalPersonalShoppingList.searchKeyword,
      priceOrder: this.state.originalPersonalShoppingList.priceOrder,
      filteringParameters,
      currentPage: 1,
    });
    this.filterClearedCompras = false;
    this.setState({ openBonusFilterModal: false });
    this.setState({ openCategoryFilterModal: false });
    this.setState({ openFilterModal: false });
  }
  searchArticleForPersonalGifts = () => {
    const searchTab = document.querySelector("#searchBoxforPersonalGifts").style
      .display;
    if (searchTab === "none") {
      document.querySelector("#searchBoxforPersonalGifts").style.display =
        "block";
    } else {
      document.querySelector("#searchBoxforPersonalGifts").style.display =
        "none";
    }
  };

  onSearchAreaKeyUp = (e) => {
    if (e.keyCode === 13) {
      // Service Call
      this.setState({
        searchKeyword: this.searchGift.getValue(),
        searchFlag: false,
      });
      this.props.handleSortAndFilter({
        searchKeyword: this.searchGift.getValue(),
        priceOrder: this.state.sortingType,
        filteringParameters: this.state.filteringParameters,
        currentPage: 1,
      });
      this.searchedValue = this.searchGift.getValue();
    }
    if (!e.target.value.length) {
      this.setState({ searchFlag: true });
      this.props.handleSortAndFilter({
        priceOrder: this.state.sortingType,
        filteringParameters: this.state.filteringParameters,
        currentPage: 1,
      });
    }
  };
  onClickSearchResult = () => {
    this.setState({
      searchKeyword: this.searchGift.getValue(),
      searchFlag: false,
    });
    this.props.handleSortAndFilter({
      searchKeyword: this.searchGift.getValue(),
      priceOrder: this.state.sortingType,
      filteringParameters: this.state.filteringParameters,
      currentPage: 1,
    });
    this.searchedValue = this.searchGift.getValue();
  };

  clearSearch = () => {
    const searchTab = document.querySelector("#searchBoxforPersonalGifts").style
      .display;
    if (searchTab === "block") {
      document.querySelector("#searchBoxforPersonalGifts").style.display =
        "none";
    }

    this.setState({ searchKeyword: "", searchFlag: true });
    this.props.handleSortAndFilter({
      priceOrder: this.state.sortingType,
      filteringParameters: this.state.filteringParameters,
      currentPage: 1,
    });
    document.getElementById("searchAreaForPersonalGift").value = "";
  };

  clearAllFilter = () => {
    this.selectedCategory = "";
    this.selectedBonusType = "";
    this.filterClearedCompras = true;
    this.setState({ filteringParameters: [] });
    this.props.handleSortAndFilter({
      searchKeyword: this.state.searchKeyword,
      currentPage: 1,
    });
  };
  priceSorting = (e) => {
    this.sortType = e.value;
    this.setState({ sortingType: this.sortType });
    this.props.handleSortAndFilter({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.sortType,
      filteringParameters: this.state.filteringParameters,
      currentPage: 1,
    });
    this.setState({ openFilterModal: false });
  };

  hideModalOverlay = () => {
    this.setState({
      comprasModal: false,
      displaySelectedProductDetail: null,
      giftSectionType: null,
    })
    document.body.classList.remove('body-no-scroll');
  }

  showModalOverlay = (giftDetail, giftSection) => {
    this.setState({
      displaySelectedProductDetail: giftDetail,
      giftSectionType: giftSection,
      comprasModal: true
    })
  }
handleSaveFilters = () => {
  this.setState({ 
    activeCategory: this.state.tempCategoryName,
    activeFilters: this.state.filteredData,
  }, () => {
    this.filterModal.handleHide();

    this.props.handleSortAndFilter({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.sortType,
      filteringParameters: this.state.filteringParameters,
      currentPage: 1,
    })
  });
};

handleClearFilters = () => {
  this.setState({ 
    selectedFilters: [],
    tempCategoryName: '',
    activeCategory: '',
    categoryDepartmentId: [],
    totalItems: '',
    activeFilters: [],
    filteringParameters: [],
    filteredCategory: [],
    filteredData: [],
  }, () => {
    this.filterModal.handleHide();

    this.props.handleSortAndFilter({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.sortType,
      currentPage: 1,
    })

    document.querySelectorAll('input[name="categoryFilterPersonalas"]').forEach(radio => {
      radio.checked = false;
    });
  });
};
 
 // category & bonus count
 //bonus
getRootLevelBonusCount = (data) =>{
  return data.totalItemsWithBonus;
}

 getRootLevelNonBonusCount = (data) =>{
  return data.totalItemsWithoutBonus;
}

//category
getItemsFromCategory = (data, selectedCategoryId) => {
  const category = data.categoryList.find(cat => cat.name === selectedCategoryId);
  return category ? category.totalItems : '0';
}
 // category & bonus count

removeFilter = (filter) => {
  if (filter.type === 'category') {
    document.querySelectorAll('input[name="categoryFilterPersonalas"]').forEach(radio => {
      radio.checked = false;
    });
  } else {
    document.querySelectorAll('input[name="bonusFilterPersonalas"]').forEach(radio => {
      radio.checked = false;
    });
  }

  const selectedFilters = this.state.selectedFilters.filter(item => item.type !== filter.type);
  const filteringParameters = this.state.filteringParameters.filter(item => item.type !== filter.type);
  
  const categoryFilter = selectedFilters.find(f => f.type === 'category');
  const bonusFilter = selectedFilters.find(f => f.type === 'bonusApplicable');

  let totalItems = '0';
  if (categoryFilter) {
    totalItems = this.getItemsFromCategory(this.props.personalShoppingList, categoryFilter.name); // only category
  } else if (bonusFilter) {
    if(filteringParameters && filteringParameters.value=='1'){
      totalItems = this.getRootLevelBonusCount(this.props.personalShoppingList); // only bonus
    }else{
      totalItems = this.getRootLevelNonBonusCount(this.props.personalShoppingList); // only non bonus
    }
   
  } else {
    totalItems = this.props?.personalShoppingList?.totalRecords ?? '0'; // no filters
  }

  this.setState({
    selectedFilters,
    filteringParameters,
    tempCategoryName: filter.type === 'category' ? '' : this.state.tempCategoryName,
    filteredCategory: filter.type === 'category' ? [] : this.state.filteredCategory,
    totalItems,
  }, () => {
    if (this.state.selectedFilters.length === 0) {
      this.setState({
        tempCategoryName: '',
        activeCategory: '',
        categoryDepartmentId: [],
        totalItems: '',
        activeFilters: [],
        filteringParameters: [],
        filteredCategory: [],
        filteredData: [],
      });

      this.props.handleSortAndFilter({
        searchKeyword: this.state.searchKeyword,
        priceOrder: this.sortType,
        currentPage: 1,
      });
    }
  });
};



handleCategoryChange = (selectedData) => {
    const categoryName = selectedData.value;
    const categoryId = selectedData.id.replace('categoryPersonalas-', '') || '';

    let filteringParameters = this.state.filteringParameters || [];
    const updatedParameters = filteringParameters.filter(item => item.type !== "category");
    if (categoryId) {
      updatedParameters.push({ "type": "category", "value": categoryId })
    }

    const selectedFilters = this.state.selectedFilters?.filter(item => item.type !== "category") || [];
    selectedFilters.push({ "type": "category", "name": categoryName })


   let filterContains = this.state.filteringParameters.find(item => item.type === "bonusApplicable")?.value || null;

    const filteredCategory = this.props.personalShoppingList.categoryList.find(
      category => category.name === categoryName
    );

    let totalItems = filteredCategory ? filteredCategory.totalItems : 0
    if (filterContains && filterContains === '0') {
      totalItems = filteredCategory.totalItemsWithoutBonus || 0
    }

    if (filterContains && filterContains === '1') {
      totalItems = filteredCategory.totalItemsWithBonus || 0
    }

    this.setState({
      tempCategoryName: categoryName,
      totalItems: totalItems,
      selectedFilters: selectedFilters,
      filteringParameters: updatedParameters,
      filteredCategory: filteredCategory,
      filteredData: selectedData.checked ? [{ type: 'category', value: categoryName }]  : [],
    });
};


handleBonificationsChange = (selectedData) => {
    const bonificatinsName = selectedData.value;
    const bonificatinsId = selectedData.id.replace('bonificacionPersonalas-', '') || '';
  
    let filteringParameters = this.state.filteringParameters || [];
    const updatedParameters = filteringParameters.filter(item => item.type !== "bonusApplicable");
    if (bonificatinsId) {
      updatedParameters.push({ "type": "bonusApplicable", "value": bonificatinsId })
    }


    const selectedFilters = this.state.selectedFilters?.filter(item => item.type !== "bonusApplicable") || [];
    selectedFilters.push({ "type": "bonusApplicable", "name": bonificatinsName })

    let filterContains = this.state.selectedFilters.find(item => item.type === "category")?.name || null;

    const filteredCategory = filterContains && this.props.personalShoppingList.categoryList.find(
      category => category.name === filterContains
    ) || [];

    let totalItems = filteredCategory ? filteredCategory.totalItems : 0
    if (!_.isEmpty(filteredCategory)) {
      if (bonificatinsId === '1') {
        totalItems = filteredCategory.totalItemsWithBonus || 0
      } else {
        totalItems = filteredCategory.totalItemsWithoutBonus || 0
      }
    }

    if (_.isEmpty(filteredCategory)) {
      if (bonificatinsId === '1') {
        totalItems = this.getRootLevelBonusCount(this.props.personalShoppingList)
      } else {
        totalItems = this.getRootLevelNonBonusCount(this.props.personalShoppingList)
      }

    }


    this.setState({
      totalItems: totalItems,
      selectedFilters: selectedFilters,
      filteringParameters: updatedParameters,
      filteredData: selectedData.checked ? [{ "type": "bonusApplicable", "value": bonificatinsId }]  : [],
    });
  };

  handleScroll = () => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    this.setState({
      showButton: scrollPercent > 25
    });
  }

  handlePDFDownload = () => {
    const downloadableContent = (<DownloadPDFWithoutPreview pageName printingDate={this.props.printingDate} download>
      <Template2
        categoryInfo={this.props.categoryInfo}
        lables={this.props.lables}
        //registeredGiftList={this.state.registeredGiftList}
        //deliveryAddressInfo={this.state.deliveryAddressInfo}
        eventDate={this.props.eventDate}
        eventId={this.props.eventId}
        eventType={this.props.eventType}
        giftCount={this.props.giftCount}
      /> </DownloadPDFWithoutPreview>);
    pdfUtil.attachToDom(downloadableContent, pageName);
  }

  render() {
   const { itemsInfo: personalPurchases = [], filteringParameters, itemsCount: totalPersonalPurchases, searchKeyword, recordsPerPage } = this.state.originalPersonalShoppingList;
    const personalPurchasesFound = _.isArray(personalPurchases) && personalPurchases.length > 0;
    const resultsPerPage = _.isFinite(Number(recordsPerPage)) ? Number(recordsPerPage) : 0;
    const showBackToTopButton = _.isArray(personalPurchases) && personalPurchases.length >= 7;
    const clearAllFiltersButtonDisabled = Object.values(this.state.appliedFilters).every(f => _.isNil(f));
    const { activeCategory } = this.state;


      const bonificacions = [
              {
                option:
                  this.props.lables &&
                  commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.regalosrecibidos.bonus.dropdown.applicable.label"
                  ),
                value: "1",
                disabled: false,
                selected: false,
              },
              {
                option:
                  this.props.lables &&
                  commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.regalosrecibidos.bonus.dropdown.notapplicable.label"
                  ),
                value: "0",
                disabled: false,
                selected: false,
              },
            ]
    let accordianFilterData = [
      {
        title: 'Categories',
        content: (
          <div className="category-radio-group">
            {this.props.personalShoppingList?.categoryList?.map((ele, idx) => (
              ele.name ?
              (<div key={idx} className="radio-label-wrapper">
                <span>{ele.name}</span>
                <RadioButton
                  id={`categoryPersonalas-${ele.id}`}
                  name="categoryFilterPersonalas"
                  value={ele.name}
                  displayName=""
                  radioCssClass="radio filter-radio"
                  checked={this.state.tempCategoryName === ele.name}
                  onChangeFunction={this.handleCategoryChange}
                />
              </div>) : null
            ))}
          </div>

        ),
        showOnLoad: true,
      }
    ]
    if(this.props.eventType !== defaultConst.eventType.Others){
      accordianFilterData.push({
        title: 'Bonificación',
        content: (
          <div className="category-radio-group">
            {bonificacions?.map((ele, idx) => (
              <div key={idx} className="radio-label-wrapper">
                <span>
                  {ele.option}
                  {
                    ele.value === '1' ? (
                      <span className="tag-count">({this.state.filteredCategory?.totalItemsWithBonus ?? this.props.personalShoppingList?.totalItemsWithBonus})</span>
                    ) :
                      (
                        <span className="tag-count">({this.state.filteredCategory?.totalItemsWithoutBonus ?? this.props.personalShoppingList?.totalItemsWithoutBonus})</span>
                      )
                  }
                </span>
                <RadioButton
                  id={`bonificacionPersonalas-${ele.value}`}
                  name="bonusFilterPersonalas"
                  value={ele.option}
                  displayName=""
                  radioCssClass="radio filter-radio"
                  checked={this.state.filteringParameters.find(item => item.type === "bonusApplicable")?.value === ele.value}
                  onChangeFunction={this.handleBonificationsChange}
                />
              </div>
            ))}
          </div>

        ),
        showOnLoad: true,
      });
    }

  const SaveButtonforFilter = {
      type: 'button',
      value: `Ver ${this.state.totalItems} artículos`,
      autoFocus: false,
      style: `btn customButtonGuardar ${this.state.activeFilters?.length === 0 ? 'widthFull' : ''}`,
      cssStyle: { backgroundColor: this.state.filteringParameters?.length > 0 && parseInt(this.state.totalItems) > 0 && this.props.activeThemeColor },
      onClickHandler: this.handleSaveFilters,
      disabled: this.state.filteringParameters.length === 0 || (this.state.totalItems && (parseInt(this.state.totalItems)=== 0))
    };

const ClearButtonforFilter = {
      type: 'button',
      value: "Limpiar filtros",
      autoFocus: false,
      style: 'btn customButtonLimpiar',
      cssStyle: { border: `1px solid ${this.props.activeThemeColor || '#333'}`, color: this.props.activeThemeColor || '#333' },
      onClickHandler: this.handleClearFilters,
    };

    const FilterArticleButton = {
      type: 'button',
      id: 'filterArticle',
      style: 'mobileWhiteButton filter-wap-button wapFilterCount',
      value: commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.regalosrecibidos.filter.by.label1"),
      filteredProducts: this.state.selectedFilters ? this.state.selectedFilters.length : 0,
      activeCategory: this.state.activeFilters?.length > 0,
      disabled: !personalPurchasesFound,
      cssStyle: { opacity: personalPurchasesFound ? '100%' : '33%' },
      beforeIconClass: 'icon-tune',
      onClickHandler: () => this.filterModal.handleShow(),
    };

    const loadMoreButton = {
      id: 'nextButton',
      type: 'button',
      value: 'Cargar más productos',
      autoFocus: false,
      style: 'btnSecondarySpecial size-Full',
      iconClass: '',
      onClickHandler: () => this.props.handleSortAndFilter({
        searchKeyword: this.searchGift.getValue(),
        priceOrder: this.state.sortingType,
        filteringParameters: this.state.filteringParameters,
        currentPage: Number(this.state.originalPersonalShoppingList.currentPage) + 1,
      }),
      cssStyle: {
        height: '48px',
        fontFamily: 'robotoRegular',
      },
    };

    const goToTopButton = {
      id: 'goToTopOfList',
      type: 'button',
      value: <img src={commonUtil.getAssetURL() + "/images/arrow_upward.svg"} style={{height: '32px'}} />,
      autoFocus: false,
      style: 'size-Full goToTopOfList',
      iconClass: '',
      onClickHandler: commonUtil.goToTop,
      cssStyle:{
        backgroundColor: `var(--500, ${this.props.activeThemeColor})`
      }
    };

    this.filterTypeCompras =
      !_.isEmpty(this.state.filteringParameters) && !this.filterClearedCompras
        ? this.state.filteringParameters
        : null;
    if (!_.isEmpty(this.filterTypeCompras)) {
      this.filterTypeCompras.map((selectedFilter) => {
        if (selectedFilter.type === "category") {
          this.selectedCategoryType = selectedFilter;
          if (this.selectedCategoryType.value === "") {
            this.selectedCategory = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.comparas.category.dropdown.label"
            );
          } else if (this.selectedCategory === "") {
            // { this.selectedCategory = this.selectedCategoryType.value;
            this.selectedCategory = _.find(this.props.comprasCategory, {
              id: this.selectedCategoryType.value,
            }).name;
          }
        }
        if (selectedFilter.type === "bonusApplicable") {
          this.selectedBonus = selectedFilter;
          if (this.selectedBonus.value === "0") {
            this.selectedBonusType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.comparas.bonus.not.applicable.label"
            );
          }
          if (this.selectedBonus.value === "1") {
            this.selectedBonusType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.comparas.bonus.applicable.label"
            );
          }
          if (this.selectedBonus.value === "") {
            this.selectedBonusType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.comparas.bonus.dropdown.label"
            );
          }
        }

        return selectedFilter;
      });
    }

    const SortArticleButton = {
      type: 'button',
      id: 'sortArticle',
      style: 'mobileWhiteButton sort-wap-button',
      value: this.state.sortingType === 'Ascending' ? commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.lowest.wap.label'): commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.wap.label'),
      onClickHandler: () => {
        this.sortType = this.state.sortingType === 'Ascending' ? 'Descending' : 'Ascending'
        this.setState({ sortingType: this.sortType });
        this.props.handleSortAndFilter({
          priceOrder: this.sortType,
          searchKeyword: this.state.searchKeyword,
          filteringParameters: this.state.filteringParameters,
          currentPage: Number(this.state.originalPersonalShoppingList.currentPage),
        })
      },
      disabled: !personalPurchasesFound,
      cssStyle: { opacity: personalPurchasesFound ? '100%' : '33%' },
      beforeIconClass: 'icon-swap',
      iconClass: 'glyphicon glyphicon-chevron-down sortIcon',
    };

    const SearchArticleButton = {
      type: "button",
      id: "searchArticle",
      style: "mobileWhiteButton buscar-wap-button",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.search.article"
      ),
      onClickHandler: this.searchArticleForPersonalGifts,
    };


   
    const FilterBackButton = {
      type: "button",
      id: "filter",
      style: "filterBackButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.to.return"
      ),
      onClickHandler: this.closeFilterModal,
    };
    const ClearFilterButton = {
      id: "clearFilterButton",
      type: "button",
      style: "filterCleanButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.clear.filters"
      ),
      onClickHandler: this.clearAllFilter,
    };
    const FilterForBonusBackButton = {
      type: "button",
      style: "filterBackButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.to.return"
      ),
      // iconClass: 'fa fa-angle-left',
      onClickHandler: this.closeModalForBonus,
    };
    const ClearFilterButtonForBonus = {
      id: "clearFilterForBonusCompras",
      type: "button",
      style: "filterCleanButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.clear.filters"
      ),
      onClickHandler: this.clearAllFilter,
    };
    const FilterForCategoryBackButton = {
      type: "button",
      style: "filterBackButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.to.return"
      ),
      // iconClass: 'fa fa-angle-left',
      onClickHandler: this.closeModalForCategory,
    };
    const ClearFilterButtonForCategory = {
      id: "clearFilterForCategory",
      type: "button",
      style: "filterCleanButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.clear.filters"
      ),
      onClickHandler: this.clearAllFilter,
    };

    const BonusFilter = {
      htmlId: "BonusFilter",
      title: "BonusFilter",
      displayName: "BonusFilter",
      name: "BonusFilter",
      defaultValue: "BonusFilter",
      options: [
        {
          id: "giftListBonificación",
          value: "",
          title: "Bonificacion(todos)",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.comparas.bonus.dropdown.label"
          ),
          labelResourceId: "Bonificacion(todos)",
          defaultChecked:
            this.selectedBonus.type === "bonusApplicable" &&
            this.selectedBonus.value === "",
        },
        {
          id: "bonusApplicable",
          value: "1",
          title: "Aplica para bonificación",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.comparas.bonus.applicable.label"
          ),
          labelResourceId: "Aplica para bonificación",
          defaultChecked:
            this.selectedBonus.type === "bonusApplicable" &&
            this.selectedBonus.value === "1",
        },
        {
          id: "bonusNotApplicable",
          value: "0",
          title: "No aplica para bonificación",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.comparas.bonus.not.applicable.label"
          ),
          labelResourceId: "No aplica para bonificación",
          defaultChecked:
            this.selectedBonus.type === "bonusApplicable" &&
            this.selectedBonus.value === "0",
        },
      ],
    };

    /* Modal for filter */
 
    const headerData = (
      <div>
        <span className="choosenOption" style={{ display: "none" }} />
        <table className="tableFilterOptions">
          <tbody>
            <tr className="optionFilter">
              <td>
                <i className="icon-flecha_gruesa_izq" />
                <InputButton buttonAttr={FilterBackButton} />
              </td>
              <td>
                <InputButton buttonAttr={ClearFilterButton} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );

    /* Modal for Bonus */
    const modalLinkForBonus = (
      <tr className="optionFilter" rel="bono" onClick={this.showBonusModal}>
        {!this.props.compareEventStatus(this.props.eventType, eventTypes) ? (
          <React.Fragment>
            <td>
              <p className="textCategory">
                {commonUtil.getLabel(
                  this.props.lables.EventAdminPage,
                  "adminpage.comparas.bonus.label"
                )}
              </p>
              <p className="sub2">{this.selectedBonusType}</p>
            </td>
            <td>
              <i className="icon-flecha_lightsvg_derecha" aria-hidden="true" />
            </td>
          </React.Fragment>
        ) : (
          ""
        )}
      </tr>
    );
    const headerDataForBonus = (
      <table className="tableFilterOptions">
        <tbody>
          <tr className="optionFilter">
            <td>
              <i className="icon-flecha_gruesa_izq" />
              <InputButton buttonAttr={FilterForBonusBackButton} />
            </td>
            <td>
              <InputButton buttonAttr={ClearFilterButtonForBonus} />
            </td>
          </tr>
        </tbody>
      </table>
    );

    /* Modal for Category Filter */

    const modalLinkForCategoryFilter = (
      <tr
        className="optionFilter"
        rel="category"
        onClick={this.showCategoryModal}
      >
        <td>
          <p className="textCategory">
            {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.comparas.category.label"
            )}
          </p>
          <p className="sub">{this.selectedCategory}</p>
        </td>
        <td>
          <i className="icon-flecha_lightsvg_derecha" aria-hidden="true" />
        </td>
      </tr>
    );
    const headerDataForCategoryFilter = (
      <table className="tableFilterOptions">
        <tbody>
          <tr className="optionFilter">
            <td>
              <i className="icon-flecha_gruesa_izq" />
              <InputButton buttonAttr={FilterForCategoryBackButton} />
            </td>
            <td>
              <InputButton buttonAttr={ClearFilterButtonForCategory} />
            </td>
          </tr>
        </tbody>
      </table>
    );

    let personalShoppingList = [];
    const { personalItemsInfo } = this.props;
    if (this.props.personalShoppingList) {
      personalShoppingList = this.props.personalShoppingList;
    }

    const selectCategory = {
      name: "selectCategory",
      options: [
        {
          id: "giftListCategoría",
          value: "",
          title: "categorias(todas)",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.comparas.category.dropdown.label"
          ),
          labelResourceId: "categorias(todas)",
          defaultChecked:
            this.selectedCategoryType.type === "category" &&
            this.selectedCategoryType.value === "",
        },
      ],
    };

    // if (personalShoppingList && personalShoppingList.categoryList) {
    if (personalShoppingList && this.props.comprasCategory) {
      const newSet = new Set();
      // personalShoppingList.categoryList.filter((category) => {
      this.props.comprasCategory
        .filter((category) => {
          if (newSet.has(category.name)) {
            return false;
          }
          newSet.add(category.name);
          return true;
        })
        .map((category) =>
          selectCategory.options.push({
            id: category.id,
            value: category.id,
            displayName: category.name,
            defaultChecked:
              this.selectedCategoryType.type === "category" &&
              this.selectedCategoryType.value === category.id,
          })
        );
    }
    // Radio button for Sorting
    const PriceBasedSorting = {
      htmlId: "priceBasedSorting",
      title: "priceBasedSorting",
      displayName: "priceBasedSorting",
      name: "priceBasedSorting",
      options: [
        {
          id: "Ascending",
          value: "Ascending",
          title: "Menor precio",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.comparas.lower.price.by.label"
          ),
          labelResourceId: "Menor precio",
          defaultChecked: personalShoppingList.priceOrder === "Ascending",
        },
        {
          id: "Descending",
          value: "Descending",
          title: "Mayor precio",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.comparas.best.price.by.label"
          ),
          labelResourceId: "Mayor precio",
          defaultChecked: personalShoppingList.priceOrder === "Descending",
        },
      ],
    };

    const totalRecords = personalShoppingList.itemsCount;
    const loadedRecordCount = personalItemsInfo ? personalItemsInfo.length : 0;
    const currentPage = personalShoppingList.currentPage;
    const sortType = this.state.sortingType;
    this.props.setTotalRecordsForType(
      "tabpersonal",
      totalRecords,
      loadedRecordCount,
      sortType,
      currentPage
    );

    const html = personalPurchasesFound && personalPurchases.map((giftDetail, index) => (
      <Template1
        eventType={this.props.eventType}
        selectedProductForPreview={this.showModalOverlay}
        compareEventStatus={this.props.compareEventStatus}
        key={index}
        giftDetail={giftDetail}
        lables={this.props.lables}
        eventContractInfo={this.props.eventInfo.contractInfo}
      />
    ));

    if (this.state.displayProductPage) {
      return <ProductDetails labels={this.props.lables} />;
    }

    return (
      <div className="container wrap">
        <div className="row">
        {
          this.state.comprasModal && 
          <ComprasModalOverlay 
            isComprasModal={true}
            isWap={true}
            title={commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.comparas.modal.header.label')}
            hideModalOverlay={this.hideModalOverlay}
            giftSectionType={this.state.giftSectionType}
            selectedProduct={this.state.displaySelectedProductDetail} 
            eventId={this.props.eventId}
            lables={this.props.lables}
            compareEventStatus={this.props.compareEventStatus}
            eventType={this.props.eventType}
            filterParams={this.state.filteringParameters}
            showMessagePopUp={this.props.showMessagePopUp}
            selectedTheme={this.props.selectedTheme}
          />
        }

          {(personalPurchasesFound || !_.isEmpty(filteringParameters) || !_.isEmpty(searchKeyword)) && (
            <Fragment>
              <div className="col-xs-12 giftList-filters giftlist-wap-filters">
                <div className="row">
                  <div className="col-xs-6">
                    <InputButton buttonAttr={SearchArticleButton} />
                  </div>
                  <div className="col-xs-6"></div>
                </div>

                <div className="row searchProductBlockRegistered" id="searchBoxforPersonalGifts" style={{ display: "none" }}>
                  <div className="col-xs-12 wrap">
                    <div className="input-group">
                      <TextInput
                        className="form-control"
                        htmlId="searchAreaForPersonalGift"
                        placeholder={commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          "adminpage.comparas.searchbox.label"
                        )}
                        required="true"
                        star=""
                        ref={(txt) => (this.searchGift = txt)}
                        onKeyUp={this.onSearchAreaKeyUp}
                      />
                      <span className="input-group-btn">
                        {this.state.searchFlag ? (
                          <button
                            className="btn btn-default"
                            type="button"
                            onClick={this.onClickSearchResult}
                          >
                            <i className="icon-zoom" />
                          </button>
                        ) : (
                          <button
                            className="btn btn-default"
                            type="button"
                            onClick={this.clearSearch}
                          >
                            <i className="icon-tache2" />
                          </button>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            <div className="col-xs-12 giftList-filters giftslist-wap-double-button-container">
              <div className="row">
                <div className="col-xs-4">
                  <InputButton buttonAttr={FilterArticleButton} activeThemeColor={this.props.activeThemeColor} />
                </div>
                  {totalRecords > 0 &&
                <div className="col-xs-8 pr-0">
                  <InputButton buttonAttr={SortArticleButton} />
                </div>}
              </div>
                </div>


             
            
              <div className="col-xs-6">
                {/* Modal for filters */}
                <WapFilterModal
                  open={this.state.openFilterModal}
                  onCloseClick={() => this.setState({ openFilterModal: false })}
                  clearAllFiltersButtonDisabled={clearAllFiltersButtonDisabled}
                  onClearAllFiltersButtonClick={this.clearAllFilter}
                >
                  <p className="textCategory">
                    {commonUtil.getLabel(
                      this.props.lables.EventAdminPage,
                      "adminpage.comparas.filter.by.label"
                    )}
                    :
                  </p>
                  <table className="tableFilter">
                    <tbody>
                      {/* Modal for Category Filters */}
                      {modalLinkForCategoryFilter}
                      {/* Modal for bonus */}
                      {modalLinkForBonus}
                    </tbody>
                  </table>
                  <br />
                  <p className="textCategory">
                    {commonUtil.getLabel(
                      this.props.lables.EventAdminPage,
                      "adminpage.comparas.price.dropdown.label"
                    )}
                  </p>
                  <table className="tableFilter">
                    <tbody>
                      {PriceBasedSorting.options.map((option, index) => (
                        <tr key={index} className="optionFilter">
                          {" "}
                          <td className="textCategory"> {option.displayName} </td>
                          <td>
                            <div className="radio">
                              <input
                                type="radio"
                                checked={this.state.originalPersonalShoppingList.priceOrder === option.value}
                                onChange={() => this.priceSorting({ value: option.value })}
                                id={`${index}-${option.value}-${option.displayName}`}
                              />
                              <label htmlFor={`${index}-${option.value}-${option.displayName}`} />
                            </div>
                          </td>{" "}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <input
                    className="location"
                    style={{ display: "none" }}
                    type="text"
                    defaultValue="filters"
                  />
                </WapFilterModal>
              </div>
            </Fragment>
          )}
          
          {personalPurchasesFound && (
            <div className="col-xs-12 text-right totalProductsCount">
              <div>
                  <b>{personalPurchases.length} de {totalPersonalPurchases}</b> productos
              </div>
            </div>
          )}
          <div className="col-xs-12 giftlist-table-bg">
            <table className="tablePersonalShopping tabelPersonalShoping_one">
              {personalPurchasesFound ? (
                <tbody>{html}</tbody>
              ) : (
                <EmptyGiftListIndicator giftList={`${this.initialPersonalPurchaseList.totalRecords == 0 ? "personalPurchases" : "personalPurchases_noSearchResults"}`} style={{ marginTop: '2rem' }} />
              )}
            </table>
          </div>
        </div>
        <div className="row text-center" style={{ marginTop: '3rem' }}>
          {personalPurchases.length < totalPersonalPurchases && (
            <div className="col-xs-12" style={{ marginBottom: '1rem' }}>
              <InputButton buttonAttr={loadMoreButton} />
            </div>
          )}
          {personalPurchasesFound && (
            <Fragment>
              {/* <div className="col-xs-12">
                {personalPurchases.length} de {totalPersonalPurchases} resultados
              </div> */}
              {showBackToTopButton && this.state.showButton && (
                <div className="col-xs-12">
                  <InputButton buttonAttr={goToTopButton} />
                </div>
              )}
            </Fragment>
          )}
        </div>


        <AddGiftsButton
          selectedTheme ={this.props.selectedTheme}
          lables = {this.props.lables}
          isDisable = {this.props.disableAnadirRegalos || false}
        />

        {/* Modal for Category Filters */}
        <WapFilterModal
          open={this.state.openCategoryFilterModal}
          onCloseClick={() => this.setState({ openCategoryFilterModal: false })}
          clearAllFiltersButtonDisabled={clearAllFiltersButtonDisabled}
          onClearAllFiltersButtonClick={this.clearAllFilter}
          nested
        >
          <table className="tableFilter">
            <tbody>
              {selectCategory.options.map((option, index) => (
                <tr className="optionFilter">
                  {" "}
                  <td className="textCategory"> {option.displayName} </td>
                  <td>
                    <div className="radio" key={index}>
                      <input
                        type="radio"
                        id={`category-${option.value}`}
                        checked={this.state.appliedFilters.category === option.value}
                        onChange={() => this.handleCategorySelection('category', option.value, option.displayName)}
                      />
                      <label htmlFor={`category-${option.value}`} />
                    </div>{" "}
                  </td>{" "}
                </tr>
              ))}
            </tbody>
          </table>
        </WapFilterModal>

        <WapFilterModal
          open={this.state.openBonusFilterModal}
          onCloseClick={() => this.setState({ openBonusFilterModal: false })}
          clearAllFiltersButtonDisabled={clearAllFiltersButtonDisabled}
          onClearAllFiltersButtonClick={this.clearAllFilter}
          nested
        >
          <table className="tableFilter">
            {!this.props.compareEventStatus(
              this.props.eventType,
              eventTypes
            ) ? (
              <tbody>
                {BonusFilter.options.map((option, index) => (
                  <tr className="optionFilter">
                    {" "}
                    <td> {option.displayName} </td>
                    <td>
                      <div className="radio" key={index}>
                        <input
                          type="radio"
                          id={`bonus-applicable-${option.value}`}
                          checked={this.state.appliedFilters.bonusApplicable === option.value}
                          onChange={() => this.handleCategorySelection('bonusApplicable', option.value, option.displayName)}
                        />
                        <label htmlFor={`bonus-applicable-${option.value}`} />
                      </div>{" "}
                    </td>{" "}
                  </tr>
                ))}
              </tbody>
            ) : (
              ""
            )}
          </table>

          <input
            className="location"
            type="text"
            defaultValue="categoryFilter"
            style={{ display: "none" }}
          />
        </WapFilterModal>

         <ModalPopover
            modalId="filterModal" dismiss="false" isModal="true" isWapFull="true"
            ref={filterModal => this.filterModal = filterModal}
            dataBackDrop="false"
          >
            <div className="wrap wrapWap">
              <div className="row headOptionModal">
                <div className="col-xs-8"> <span className="titleOptionModal"> Filtrar </span></div>
                <div className="col-xs-4 text-right closeOptionModal" onClick={this.handleClearFilters}><img
                  src={commonUtil.getAssetURL() + "/images/close.svg"}
                  alt=""
                  className="icon_vozcliente"
                /></div>
              </div>
              <div className="filter-container">
                {this.state.activeFilters.length > 0 && this.state.selectedFilters.map((filter, idx) => (
                  <FilterTag
                    key={idx}
                    label={filter.name}
                    onRemove={() => this.removeFilter(filter)}
                  />
                ))}
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <div className='row'>
                    <div className='mode_filter_change' style={{ padding: '0px 24px'}}>
                     <Accordion items={accordianFilterData} isOpenFilter={true} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <div className="filter-button-group">
                   {this.state.activeFilters?.length > 0 && (
                    <InputButton 
                      buttonAttr={ClearButtonforFilter}
                    />
                  )}
                  <InputButton 
                    buttonAttr={SaveButtonforFilter}
                  />
                </div>
              </div>
            </div>
          </ModalPopover>
      </div>
    );
  }
}

export default ComprasPersonalesWAP;
